import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem, MuiThemeProvider,
Grid, Divider, Dialog, Slide, DialogTitle, DialogContent, DialogContentText, Hidden } from '@material-ui/core';
import { } from '@material-ui/icons';
import  AddIcon  from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete'
import CircularProgress from '@material-ui/core/CircularProgress';
import creds from '../config/firebaseConfig';
import db from '../config/firestoreConfig';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        position: 'relative',
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
        },
    paper: {
        padding: theme.spacing.unit * 2,
        position: 'relative',
        paddingBottom: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        height: 'auto',
        overflowX: 'auto',
        width: '75%'
        },
    button: {
        margin: theme.spacing.unit,
        padding: 40,
        width: 150, 
        height: 150,
        },
    fab: {
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 8,
        },
    fab2: {
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
        },
    textField: {
        paddingTop: 20,
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
        },
    progress: {
        margin: theme.spacing.unit * 2,
        },
})
class manageYears extends Component{
    constructor(props){
        super(props)
        this.state = {
            yearName: [],
            subjectContent: [],
            open: false,
            openDelete: false,
            loading: true,
        }
    }

    async componentDidMount(){
        const obj = await this.fetchData()
        this.setState({
            ...this.state,
            yearName: obj.nameArr, 
            subjectContent: obj.contentArr
        })
    }

    async fetchData() { 
        const ref = db.collection('Level').doc(this.props.match.params.level).collection('Subjects').doc(this.props.match.params.subject).collection('Years').orderBy('id');
        const nameArr = [];
        const contentArr = [];
        try {
            const snapshot = await ref.get()
            snapshot.forEach(year => {
                const res = year.data()
                nameArr.push(res.id)
                contentArr.push(res)
            })
            const obj = {
                'nameArr': nameArr,
                'contentArr': contentArr
            }
            return obj
        } catch (e) { 
            console.log('there was an error')
        }
    }

    handleClose = (name) => {
        this.setState({
            [name]: false
        })
    }

   hanldeOpen = (name) => { 
       this.setState({
           ...this.state,
           [name]: true
       })
   }

   handleChange = (name) => event => { 
       this.setState({
           ...this.state,
           [name]: event.target.value
       })
       console.log(event.target.value)
   }

//    createYear = (name)  => { 
//         if (name.length > 0) {
//             try {
//                 const abilityArr = ['Beginner', 'Intermediate', 'Advanced']
//                 const data = {
//                     Classes: [],
//                     Content:{ 
//                         Sections: [],
                        
//                     },
//                     Members: [],
//                 };
//                 const subjRef = db.collection('Level').doc(this.props.match.params.level).collections('Subjects')
//                 const yearsRef = db.collection('Level').doc(this.props.match.params.level).collection('Subjects').doc(this.props.match.params.subject).collection('Years')
//                 yearsRef.doc(name).set({
//                     id: (name)
//                 }, {merge: true})
//                     .then(()=> {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
//                         window.alert('here')
//                         abilityArr.forEach(ability => {
//                             yearsRef.where('id', '==', name).get()
//                             .then(querySnapshot => {
//                                 console.log('here 2')
//                                 querySnapshot.forEach(doc => {
//                                 console.log(doc.id)
//                                     yearsRef.doc(doc.id).collection('Abilities').doc(ability).set({
//                                         data
//                                     })
//                                 })
//                                 if (abilityArr.indexOf(ability) == abilityArr.length -1 ){
//                                 window.location.reload()
//                             }
//                             })
                            
//                         })
//                         this.setState({
//                             open:false
//                         })
                        

//                 })
//             } catch (e){ 
//                 console.error(e)
//                 window.alert('There was an error - see console for more details')
                
//             }
//         }
//     }

createYear = (name)  => { 
    if (name.length > 0) {
        try {
            const abilityArr = ['Beginner', 'Intermediate', 'Advanced']
            const data = {
                Classes: [],
                Content:{ 
                    Sections: [],
                    
                },
                Members: [],
            };
            const subjRef = db.collection('Level').doc(this.props.match.params.level).collection('Subjects')
            const yearsRef = db.collection('Level').doc(this.props.match.params.level).collection('Subjects').doc(this.props.match.params.subject).collection('Years')
            subjRef.get()
                .then(snapshot => {
                    snapshot.forEach(subject => { 
                    subjRef.doc(subject.id).collection('Years').doc(name).set({
                        id: (name)
                    }, {merge: true})
                        .then(()=> {                                                                                                                                                                                                                                                                                            
                            abilityArr.forEach(ability => {
                                yearsRef.where('id', '==', name).get()
                                .then(querySnapshot => {
                                    // console.log('here 2')
                                    querySnapshot.forEach(doc => {
                                    console.log(doc.id)
                                        yearsRef.doc(doc.id).collection('Abilities').doc(ability).set({
                                            data
                                        })
                                    })
                                    if (abilityArr.indexOf(ability) == abilityArr.length -1 ){
                                        window.location.reload()
                                    }
                                })
                                
                            })
                            this.setState({
                                open:false
                            })
                            window.alert('Year Group created')
                        })
                    })
                })
            
        } catch (e){ 
            console.error(e)
            window.alert('There was an error - see console for more details')
            
        }
    }
}

    deleteYear = (name) => { 
        console.log(name)
        try { 
            db.collection('Level').doc(this.props.match.params.level).collection('Subjects').doc(this.props.match.params.subject).collection('Years').doc(name).delete()
                .then(ref =>{ 
                    console.log('Year ' + name + ' has been deleted.')
                    window.location.reload()
                })
        } catch (e) {
            console.error(e)
        }
    }

    render(){
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <Typography variant='headline'>
                        Manage years for 
                    </Typography>
                    <Button onClick={() => {window.location.replace('/' + this.props.match.params.id + '/' + this.props.match.params.acctype + '/' + 'managelevels/' + this.props.match.params.level)}}> 
                        {this.props.match.params.level} 
                    </Button>
                     - 
                    <Button color='secondary' onClick={() => {window.location.replace('/' + this.props.match.params.id + '/' + this.props.match.params.acctype + '/' + 'managelevels/' + this.props.match.params.level + '/' + this.props.match.params.subject)}}> 
                        {this.props.match.params.subject} 
                    </Button>
                    <Divider/>
                    {this.state.subjectContent.length > 0 ? (
                        <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='center'
                        >
                            {this.state.yearName.map(year => {
                                return (
                                    <Grid item xs={3}>
                                        <Button variant='outlined' className={classes.button} onClick={() => window.location.replace(this.props.match.url + '/' + year)}  value={year}>
                                            {year}
                                        </Button>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    ) : (
                        <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='center'
                        >
                            <br/>
                            {this.state.loading ? 
                                <Grid item xs={12}>
                                        <div style={{width: '100%', alignItems: 'center'}}>
                                            <CircularProgress className={classes.progress} color="inherit" />
                                        </div> 
                                        {setTimeout(() => {this.setState({loading: false})}, 2000)}
                                </Grid>  
                            :
                                <Grid item xs={12}>
                                    <Typography variant='subheading' style={{marginTop: 20}}>
                                        You have no year groups for this subject
                                    </Typography>
                                </Grid> 
                            }
                        </Grid>
                    )}
                    <Button variant='fab' mini color='primary' className={classes.fab} onClick={() => this.hanldeOpen('open')}>
                        <AddIcon/>
                    </Button>
                    <Button variant='fab' mini color='primary' className={classes.fab2} onClick={() => this.hanldeOpen('openDelete')}>
                        <DeleteIcon/>
                    </Button>
                    <Dialog
                        open={this.state.open}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => this.handleClose('open')}
                        aria-labelledby='form-dialog-title'
                    >
                        <DialogTitle id='form=dialog-title'>Create new year group</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                What is the new year group
                            </DialogContentText>
                            <form className={classes.container}>
                                <TextField
                                    id='levelName'
                                    className={classes.TextField}
                                    value={this.state.newSubject}
                                    placeholder='Enter a name here'
                                    onChange={this.handleChange('newSubject')}
                                >
                                </TextField>
                                <br/>
                                <br/>
                                <br/>
                                <Button variant='raised' color='inherit'  align='center' onClick={() => this.createYear(this.state.newSubject)}>
                                    Add Year Group
                                </Button>
                            </form>
                        </DialogContent>
                    </Dialog>
                    <Dialog
                        open={this.state.openDelete}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => this.handleClose('openDelete')}
                        aria-labelledby='form-dialog-title'
                    >
                        <DialogTitle id='form=dialog-title'>Delete a year group</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Which year would you like to delete?
                            </DialogContentText>
                            <form className={classes.container}>
                                <TextField
                                    id='subjectDelete'
                                    select
                                    className={classes.TextField}
                                    value={this.state.deleteYear}
                                    placeholder='Please select one'
                                    onChange={ this.handleChange('deleteYear')}
                                >
                                    {this.state.yearName.map(year =>{
                                        return (
                                            <MenuItem key={year} value={year}>
                                                {year}
                                            </MenuItem>
                                        )
                                    })}
                                </TextField>
                                <br/>
                                <br/>
                                <br/>
                                <Button variant='raised' color='inherit'  align='center' onClick={() => this.deleteYear(this.state.deleteYear)}>
                                    Delete year group
                                </Button>
                            </form>
                            
                        </DialogContent>
                    </Dialog>
                </Paper>
            </div>
        )
    }
}
export default withStyles(styles)(manageYears);


// WEBPACK FOOTER //
// ./src/admin/manageYears.jsx